import React from "react";
import { Box, CircularProgress, Switch, Typography } from "@mui/material";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import { Contact } from "../../../interfaces/DTO/crm/contact";
import { usePartialUpdateContact } from "../../../hooks/crm/useContacts";

interface HeverMembershipCardProps {
  contact: Contact;
}

/** חבר בחבר – כרטיס קטן משלו עם מתג; נשמר מיד */
const HeverMembershipCard: React.FC<HeverMembershipCardProps> = ({ contact }) => {
  const updateContact = usePartialUpdateContact();

  return (
    // the same look as EditableFieldsBlock - the blocks above it
    <Box
      sx={{ width: "100%", px: 2, py: 1, borderRadius: 2, boxShadow: 1, backgroundColor: "background.default", display: "flex", alignItems: "center", gap: 1.5 }}
    >
      <CardMembershipIcon color="action" fontSize="small" />
      <Typography sx={{ flex: 1 }} fontWeight={contact.has_hever ? 700 : 400}>
        חבר בחבר
      </Typography>
      {updateContact.isPending && <CircularProgress size={16} />}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2" color="text.secondary">
          {contact.has_hever ? "כן" : "לא"}
        </Typography>
        <Switch
          checked={contact.has_hever === true}
          disabled={updateContact.isPending}
          onChange={(e) => updateContact.mutate({ id: contact.id!, fields: { has_hever: e.target.checked } })}
        />
      </Box>
    </Box>
  );
};

export default HeverMembershipCard;
